import type { TBuildingObjectType } from 'shared/types/buildingCard';

/** Заголовок блока похожих — как `offer_card_list.tsx` монолита: у складов и нештатного типа без уточнения */
export function getSimilarBuildingsTitle(type: TBuildingObjectType | null): string {
  switch (type) {
    case 'businessCenter':
      return 'Похожие бизнес-центры';
    case 'shoppingCenter':
      return 'Похожие торговые центры';
    default:
      return 'Похожие';
  }
}
